module.exports = __webpack_public_path__ + "static/img/wei.png";